import angular from 'angular';
import QueryRule from '~/scripts/services/model/query-rule';
import QueryVariable from '~/scripts/services/model/query-variable';
import QueryWhereRule from '~/scripts/services/model/query-where-rule';

export default class QueryRuleVariableController {
	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {any} KTranslate
	 */
	constructor(
		$scope,
		$timeout,
		KTranslate,
	) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.KTranslate = KTranslate;

		/** @type {?import('../query-editor/query-editor.controller').default} */
		this.bEditor = null;

		/** @type {?import('../query-builder/query-builder.controller').default} */
		this.builder = null;

		/** @type {boolean} */
		this.dropDownOpened = false;

		/** @type {?import('../query-editor/query-editor.controller').default} */
		this.editor = null;

		/** @type {?QueryWhereRule | ?QueryRule} */
		this.rule = null;

		this.isAddingVariable = undefined;
		this.newVariableForm = undefined;
		this.newVariableId = undefined;
		this.variableIdRegex = QueryVariable.getVariableIdRegex();
	}

	/**
	 * @param {Event} event
	 * @param {string} id
	 */
	createRuleVariable(event, id) {
		if (!this.editor || !this.rule || !this.rule.operator) {
			console.warn('You are not allowed to create rule variable here!');
			return;
		}

		event.preventDefault();
		const variable = new QueryVariable();
		variable.id = id.trim();
		variable.operator = this.rule.operator;
		if (this.rule instanceof QueryWhereRule) {
			const node = this.rule.getNode();
			if (node) {
				variable.field = this.rule.field;
				variable.isa = node.kid;
				variable.isa_linker_kid = node.linker_kid;
				variable.name = node.name;
				variable.type = node.type;
			}
		}
		else if (this.rule instanceof QueryRule) {
			// @ts-ignore
			variable.isa = this.rule.field;
			variable.type = this.rule.type || null;
		}
		this.editor.createVariable(variable);
		this.rule.value = undefined;
		this.rule.variable = variable.id;
		this.isAddingVariable = undefined;
		this.dropDownOpened = false;
	}

	removeInputVariable() {
		if (!this.editor || !this.rule) {
			console.warn('You are not allowed to delete rule variable here!');
			return;
		}

		let oldVariable;
		// remove variable is unused
		const rulesFound = this.editor?.tab?.query.findRule(
			(/** @type {QueryWhereRule | QueryRule} */ r) => r.variable === this.rule?.variable,
		);
		if (typeof rulesFound !== 'undefined') {
			oldVariable = this.editor.findVariable(this.rule.variable);
		}
		this.rule.variable = undefined;
		if (oldVariable) {
			this.editor.deleteVariable(oldVariable);
		}
	}

	/**
	 * @param {Event} event
	 */
	showAddVariable(event) {
		if (!this.rule) {
			return;
		}
		event.preventDefault();
		event.stopImmediatePropagation();

		// @ts-ignore
		const li = angular.element(event.target).closest('li');
		const label = (this.rule instanceof QueryRule && this.rule.label)
			|| (this.rule instanceof QueryWhereRule && this.rule.getNode()?.name);

		this.$timeout(() => {
			this.isAddingVariable = this.rule;
			if (label) {
				this.newVariableId = label
					.normalize('NFD')
					.replace(/[\u0300-\u036F]/g, '')
					.replace(/\W+/g, '_')
					.toLowerCase();

				const input = li.find('input');
				input.trigger('focus');
			}
		});
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {Event} event
	 */
	showAddVariableCancelEvent(event) {
		event.preventDefault();
		event.stopImmediatePropagation();
	}

	$onInit() {
		if (this.bEditor) {
			this.editor = this.bEditor;
		}
	}
}
